import {Box, IconButton} from '@miro-site/core'
import type {BoxProps, StyleProps} from '@miro-site/core'
import React, {MouseEventHandler} from 'react'
import styled, {useTheme} from 'styled-components'
import {Close} from '../icons/Icons'

export interface PopupProps extends BoxProps {
  children: React.ReactNode
  onCloseClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>
  $styles?: StyleProps
}

const Popup = React.forwardRef<HTMLElement, PopupProps>(
  ({children, onCloseClick, $styles, ...props}, ref) => {
    const theme = useTheme()

    return (
      <PopupWrapper
        ref={ref}
        $p={20}
        $pt={70}
        $styles={{
          position: 'relative',
          borderRadius: [0, 16, 16, 16],
          background: 'primaryWhite',
          ...$styles,
        }}
        {...props}
      >
        <IconButton
          label="Close popup"
          onClick={e => {
            e.preventDefault()

            if (onCloseClick) {
              onCloseClick(e)
            }
          }}
          icon={<Close />}
          $styles={{
            position: 'absolute',
            top: 20,
            right: 20,
            borderRadius: '50%',
            width: 36,
            height: 36,
            ':hover': {
              background: theme.templates.colors.secondary4,
            },
          }}
        />

        {children}
      </PopupWrapper>
    )
  },
)

Popup.displayName = 'Popup'

const PopupWrapper = styled(Box)`
  box-shadow: ${({theme}) => theme.templates.elevation.overlay};
`

export default Popup
